export const VOTE_SUCCESS_MODAL = {
  title: 'Thank you for your input',
  desc: 'Your response was successfully submitted.',
  goToFeed: 'Explore Polco in your area',
  follow: (name: string) => `You are now following ${name}.`,
};
